import * as React from "react";
import { action, computed, observable } from "mobx";
import { observer, inject } from "mobx-react";
import { Button } from "./Button";
import { IButtonProps } from "./IButtonProps";
import { FullScreen } from "./../General/FullScreen";
import { Screenfull } from "../Screenfull";
import { Strings } from "../Stores/StringsStore";


export interface IFullScreenButtonProperties extends IButtonProps {
	fullScreen?: FullScreen;
}

@inject("fullScreen")
@observer
export class FullScreenButton extends React.Component<IFullScreenButtonProperties, {}> {

	@action onClick = (event: React.MouseEvent<any>) => {
		if (this.props.fullScreen) {
			this.props.fullScreen.toggleFullScreen();
		}
	}

	@computed get isPressed(): boolean {
		return Screenfull.element !== null;
	}

	@computed get isDisabled(): boolean {
		return !(this.props.fullScreen && Screenfull.enabled);
	}

	@computed get tooltip() {
		return this.isPressed ? Strings.reader.fullScreenDisableButtonTooltip : Strings.reader.fullScreenEnableButtonTooltip;
	}

	render() {
		return <Button {...this.props} onClick={this.onClick} disabled={this.isDisabled} pressed={this.isPressed} title={this.props.title ? this.props.title : this.tooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M11.94,9.11L6.41,3.59,10,0H0V10L3.59,6.41l5.53,5.53A8,8,0,0,1,11.94,9.11Z" />
					<path d="M11.94,22.89a8,8,0,0,1-2.83-2.83L3.59,25.59,0,22V32H10L6.41,28.41Z" />
					<path d="M28.41,25.59l-5.53-5.53a8,8,0,0,1-2.83,2.83l5.53,5.53L22,32H32V22Z" />
					<path d="M22,0l3.59,3.59L20.06,9.11a8,8,0,0,1,2.83,2.83l5.53-5.53L32,10V0H22Z" />
				</svg>
			</i>
		</Button>;
	}
}
